var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6V4.59375L8 0.375L15.5 4.59375V6H14.0938H1.90625H0.5ZM8 2.01562L3.3418 4.59375H12.6289L8 2.01562ZM3.78125 6.9375V11.625H5.65625V6.9375H7.0625V11.625H8.9375V6.9375H10.3438V11.625H12.2188V6.9375H13.625V11.625H13.8594H14.5625V13.0312H13.8594H2.14062H1.4375V11.625H2.14062H2.375V6.9375H3.78125ZM0.5 13.9688H1.20312H14.7969H15.5V15.375H14.7969H1.20312H0.5V13.9688Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitution);
export default __webpack_public_path__ + "static/media/institution.018cca96cb7dc0d8fd55323abd952a24.svg";
export { ForwardRef as ReactComponent };